import { DateTime } from 'luxon';
import { useCallback } from 'react';
import { FieldError, FieldValues } from 'react-hook-form';

import { TFunction } from 'i18next';

export const getHelperText = (
	t: TFunction,
	disabled: boolean | undefined,
	error: FieldError | undefined,
	helperText?: React.ReactNode
) =>
	// Casting as 'error-unexpected' is workaround, so that typescript won't throw error.
	// Default value is not passed, so that custom translation of error message can be passed here.
	!disabled && error?.message
		? t(error.message as 'error-unexpected')
		: helperText;

export const displayError = (
	disabled: boolean | undefined,
	error: FieldError | undefined
): boolean => !disabled && Boolean(error);

export const useDatePickerFutureValidation = <
	TFieldValues extends FieldValues = FieldValues,
>(
	additionalValidation: (
		value: DateTime,
		formValues: TFieldValues
	) => string | boolean = () => true
) => {
	const validate = useCallback(
		(value: DateTime | null, formValues: TFieldValues) => {
			if (value == null) {
				// always return true if null, required validation should check this
				return true;
			}
			return value > DateTime.now()
				? 'error:no-future-date'
				: additionalValidation(value, formValues);
		},
		[additionalValidation]
	);

	return validate;
};
